import { lazy, Suspense } from "react";
import {
  Routes,
  Route,
} from "react-router-dom";
import { NotFound } from './components/NotFound/index.tsx'
import {footerLinks} from './mocks/footerlinks/index.ts'
import { GeneralWrapper } from './appWrapper/generalWrapper.ts'
import  {Header}  from './containers/Header/index.tsx'
import { Footer } from './containers/Footer/index.tsx'
import { blogs } from "./mocks/blogs/index.ts";
import { SpeedInsights } from '@vercel/speed-insights/react';
import CookiesBanner from './components/Cookies/index.tsx'

// Route-level code splitting: each page ships its own chunk so a visitor to
// /spain doesn't download chat, backoffice, date-pickers, etc. Named exports
// are re-mapped to `default` for React.lazy.
const named = (importer, name) => lazy(() => importer().then((m) => ({ default: m[name] })));

const Find              = named(() => import('./containers/Find/index.tsx'), 'Find');
const Landing           = named(() => import('./containers/Landing/index.tsx'), 'Landing');
const About             = named(() => import('./containers/About/index.tsx'), 'About');
const QuestionsAndAnswers = named(() => import('./containers/Q&A/index.tsx'), 'QuestionsAndAnswers');
const Coliving          = named(() => import('./containers/Coliving/index.tsx'), 'Coliving');
const AuthPage          = named(() => import('./containers/AuthPage/index.tsx'), 'AuthPage');
const Profile           = named(() => import('./containers/Profile/index.tsx'), 'Profile');
const CreateColiving    = named(() => import('./containers/CreateColiving/index.tsx'), 'CreateColiving');
const ColivingBackoffice = named(() => import('./containers/ColivingBackoffice/index.tsx'), 'ColivingBackoffice');
const Chat              = named(() => import('./containers/Chat/index.tsx'), 'Chat');
const Blog              = named(() => import('./components/Blog/index.tsx'), 'Blog');
const ColivingJournalList = named(() => import('./containers/ColivingJournal/List.tsx'), 'ColivingJournalList');
const ColivingJournalPost = named(() => import('./containers/ColivingJournal/Post.tsx'), 'ColivingJournalPost');
const Activities        = named(() => import('./components/Activities/index.tsx'), 'Activities');

const RouteFallback = () => (
  <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9A7858', fontFamily: "'DM Sans', sans-serif", fontSize: 14 }}>
    Loading…
  </div>
);

function App() {
  return (
    <>
      <Header />
      <GeneralWrapper as="main">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route exact path="/" element={<Find />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/questions-and-answers" element={<QuestionsAndAnswers />} />
            <Route path="/sign-up" element={<AuthPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/coliving-madrid" element={<Coliving />} />
            <Route path="/coliving-valencia" element={<Coliving />} />
            <Route path="/coliving-valencia/events/ecstatic-dance" element={<Activities />} />
            <Route path="/coliving-madrid-blog" element={<Blog blog={blogs}/>} />
            <Route path="/coliving-madrid/journal" element={<ColivingJournalList />} />
            <Route path="/coliving-madrid/journal/:slug" element={<ColivingJournalPost />} />
            <Route path="/coliving-valencia/journal" element={<ColivingJournalList />} />
            <Route path="/coliving-valencia/journal/:slug" element={<ColivingJournalPost />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/create-coliving" element={<CreateColiving />} />
            <Route path="/coliving-backoffice/:id" element={<ColivingBackoffice />} />
            <Route path="/chat/:id" element={<Chat />} />
            <Route path="/chat" element={<Chat />} />
            {footerLinks.map((link) => (
              <Route key={link.id} path={link.url} element={<Find />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </GeneralWrapper>
      <Footer />
      <CookiesBanner />
      <SpeedInsights />
    </>
  );
}

export default App;
